<template>
  <div
    id="sidenav-collapse-main"
    class="w-auto h-auto collapse navbar-collapse max-height-vh-100 h-100"
  >
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-collapse
          collapse-ref="dashboard"
          nav-text="Dashboard"
          :collapse="false"
          :to="{ name: 'Dashboard' }"
          :class="getRoute() === 'dashboard' ? 'active' : ''"
        >
          <template #icon>
            <Shop />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse
          collapse-ref="cavalli"
          nav-text="Cavalli"
          :collapse="false"
          :to="{ name: this.$store.getters.horseListMenuLink }"
        >
          <template #icon>
            <Office/>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item" v-if="isRidingStableManager">
        <sidenav-collapse
          collapse-ref="soci"
          :collapse="false"
          nav-text="Soci" 
          :to="{ name: 'Soci' }"
        >
          <template #icon>
            <Office />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item" >
        <sidenav-collapse
          collapse-ref="maneggio"
          navText="Maneggio" 
          :to="{ name: 'Maneggio' }"
          :class="getRoute() === 'scuderie' ? 'active' : ''"
        >
          <template #icon>
            <Office />
          </template>
          <template #list>
            <ul class="nav ms-4 ps-3">
              <!-- nav links -->
              <sidenav-item
                :to="{ name: 'Maneggio' }"
                mini-icon="D"
                text="Maneggio"
              />
              <sidenav-item
                :to="{ name: 'Scuderie' }"
                mini-icon="A"
                text="Scuderie"
              />
            </ul>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item"  v-if="Permissions.isInstructor(this.$store.state.user)">
        <sidenav-collapse
          collapse-ref="lezioni"
          navText="Lezioni" 
          :to="{ name: 'Lessons' }"
          :class="getRoute().includes('lessons') ? 'active' : ''"
        >
          <template #icon>
            <Office />
          </template>
          <template #list>
            <ul class="nav ms-4 ps-3">
              <!-- nav links -->
              <sidenav-item
                :to="{ name: 'Lessons' }"
                mini-icon="D"
                text="Lezioni"
              />
              <sidenav-item
                 :to="{ name: 'LessonCalendar' }"
                mini-icon="A"
                text="Lezioni Calendar"
              />
            </ul>
          </template>
        </sidenav-collapse>
      </li>
    </ul>
  </div>
  <div class="pt-3 mx-3 mt-3 sidenav-footer">
    <!-- <sidenav-card
      :class="cardBg"
      text-primary="Need Help?"
      text-secondary="Please check our docs"
      route="https://www.creative-tim.com/learning-lab/vue/overview/soft-ui-dashboard/"
      label="Documentation"
      icon="ni ni-diamond"
    /> -->
  </div>
</template>
<script>
import SidenavItem from "./SidenavItem.vue";
import SidenavCollapse from "./SidenavCollapse.vue";
//import SidenavCard from "./SidenavCard.vue";
//import SidenavCollapseItem from "./SidenavCollapseItem.vue";
// import Settings from "@/components/Icon/Settings.vue";
// import Basket from "@/components/Icon/Basket.vue";
// import Box3d from "@/components/Icon/Box3d.vue";
import Shop from "@/components/Icon/Shop.vue";
import Office from "@/components/Icon/Office.vue";
// import Document from "@/components/Icon/Document.vue";
// import Spaceship from "@/components/Icon/Spaceship.vue";
// import CreditCard from "@/components/Icon/CreditCard.vue";
import Permissions from '@/services/PermissionService';

import { mapState } from "vuex";
export default {
  name: "SidenavList",
  components: {
    SidenavItem,
    SidenavCollapse,
    //SidenavCard,
    //SidenavCollapseItem,
    // Settings,
    // Basket,
    // Box3d,
    Shop,
    Office,
    // Document,
    // Spaceship,
    // CreditCard,
  },
  props: {
    cardBg: {
      type: String,
      default: "",
    },
  },
  data() {
			return {
				isRidingStableManager: false,
        Permissions
			};
		},
    computed: {
      ...mapState(["isRTL"]),
    },
  methods: {
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    },
    setAuth() {
				if (this.$store.state.user != null) {
					this.isRidingStableManager = !!this.$store.state.user?.riding_stables
						.length;
				}
			},
		},
  beforeMount() {
    this.setAuth();
  },
};
</script>
